module.exports = __webpack_public_path__ + "static/media/img_0320.862f5c91.jpeg";